<template>
  <div class="modal fade" id="modalAddItemInOrder" tabindex="-1" aria-labelledby="modalAddItemInOrderLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalChangeItemInOrderLabel">{{ $t('orderItemAdd.addItem') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div v-for="(product, key) in this.RESTAURANTMENU" :key="product.id"
                 class="border-bottom product_column">
              <div class="p-2 product_column__title"
                   @click="selectProduct(key)"
                   :class="productSelectIndex === key ? 'bg-success bg-opacity-25' : ''">
                {{product.title}}
              </div>
              <div class="p-2" v-show="productSelectIndex === key">
                <div class="d-flex mb-3 flex-wrap gap-3">
                  <div class="btn-group" v-show="product.modifiers"  role="group" aria-label="Product variants">
                    <button v-for="variant in product.modifiers"
                            @click="setVariant(variant.title)"
                            type="button" class="btn btn-sm btn-outline-primary"
                            :class="[productVariantSelect === variant.title ? 'active' :  '' ]">
                      {{ variant.title }}
                    </button>
                  </div>
                  <div class="fs-6">{{productPrice}}{{ $t('orderItemAdd.currency') }}</div>
                  <div class="input-group product_count ms-4">
                    <button @click="productQty--" class="btn btn-sm btn-outline-secondary">-</button>
                    <input v-model.number="productQty" type="number" class="form-control form-control-sm text-center p-1">
                    <button @click="productQty++" class="btn btn-sm btn-outline-secondary">+</button>
                  </div>
                </div>
                <div v-for="mod in actualModifiers" class="mb-3" :key="mod.id">
                  <p>{{mod.title}}
                    <span class="text-muted small">{{ countSelectedOptionsInModifier(mod.id) }}/{{ mod.choose_max }}</span>
                  </p>
<!--                  Modify options-->
                  <div v-if="mod.type === 'modify'" class="d-flex flex-wrap gap-2">
                    <div v-for="option in optionInfo(mod.option_ids)">
                      <button type="button"
                              @click="countSelectedOptionsInModifier(mod.id) < mod.choose_max ? addOption(mod.id, option) : '' "
                              class="btn btn-sm btn-outline-secondary position-relative">
                        {{ option.title }}  <div class="small">({{ option.price }}{{ $t('orderItemAdd.currency') }})</div>
                        <span v-if="this.optionIsSelected(mod.id, option.id)" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                          {{this.optionIsSelected(mod.id, option.id)}}
                            <span class="visually-hidden">option qty</span>
                        </span>
                        <div v-show="checkCountOption(mod.id, option.id) > 0" class="variant-modifiers__item-btn position-absolute bottom-0 start-0">
                          <button
                              @click.stop
                              @click="reduceOption(mod.id, option.id)"
                              class="variant-modifiers__item-btn-minus btn btn-sm btn-danger">
                            <svg width="1rem" height="1rem" fill="currentColor">
                              <use xlink:href="../../../assets/ico/bootstrap-icons.svg#arrow-down"/>
                            </svg>
                          </button>
                        </div>
                      </button>
                    </div>
                  </div>
<!--                  Removed options-->
                  <div v-else-if="mod.type === 'remove'" class="d-flex flex-wrap gap-2">
                    <div v-for="option in optionInfo(mod.option_ids)">
                      <button type="button"
                              @click="countSelectedOptionsInModifier(mod.id) < mod.choose_max ? changeRemovedOption(mod.id, option) : '' "
                              :class="this.optionIsSelected(mod.id, option.id) ? 'text-decoration-line-through' : ''"
                              class="btn btn-sm btn-outline-secondary position-relative">
                        {{ option.title }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-12 col-md-5">
                      <label for="productPriceTotalAdd" class="form-label d-block">{{ $t('orderItemAdd.priceIncludeOptions') }}</label>
                      <input v-model.number="productPriceTotal" type="text" class="form-control form-control-sm d-inline w-auto"
                             id="productPriceTotalAdd">
                      <span class="ms-2">{{ $t('orderItemAdd.currency') }}</span><br>
                      <span class="small text-danger mt-2">{{ $t('orderItemAdd.amount') }}{{this.productPriceTotal * this.productQty}}{{ $t('orderItemAdd.currency') }}</span>
                    </div>
                    <div class="col-12 col-md-7">
                      <label for="commentForAdd" class="form-label">{{ $t('orderItemAdd.comment') }}<sup class="text-danger">*</sup></label>
                      <input v-model="commentForChange" type="text" class="form-control form-control-sm"
                             id="commentForAdd">
                    </div>
                  </div>
                  <span class="d-none">{{this.countProductPriceTotal}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3">

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('orderItemAdd.cancel') }}</button>
          <button
              @click="addItemInOrder()"
              :disabled="emptyComment"
              data-bs-dismiss="modal"
              type="button" class="btn btn-success">{{ $t('orderItemAdd.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "OrderItemAdd",
  data() {
    return {
      productSelected: {},
      productSelectIndex: undefined,
      productVariantSelect: '',
      productOptionsSelect: {},
      productQty: 1,
      productPrice: 0,
      productPriceTotal: 0,
      commentForChange: '',
    }
  },
  computed: {
    ...mapGetters([
        'RESTAURANTMENU',
        'MODIFIERS',
        'OPTIONS'
    ]),
    actualModifiers() { //показывает модификаторы в зависимости от выбранного варианта товара
      let product = this.productSelected
      if (this.productVariantSelect && Object.values(this.productSelected).length) {
        let modifiersInVariant = product.modifiers[this.productVariantSelect].modifier_ids
        let fullModArr = []
        for (let elem of modifiersInVariant) {
          fullModArr.push(this.MODIFIERS[elem])
        }
        return fullModArr;
      }
    },
    countPriceBody() { //цена продукта в зависимости от варианта
        let product = this.productSelected
        let priceSum = product.price
        if (this.productVariantSelect !== '') {
          if (Object.values(product.modifiers).length) { // если у продукта есть модификаторы
            priceSum += product.modifiers[this.productVariantSelect].price
          }
          this.productPrice = priceSum
        } else {
          this.productPrice = priceSum
        }
    },
    countProductModifiersPrice() { //подсчет суммы всех выбранных опций
      let total = 0
      let allOption = Object.values(this.productOptionsSelect)
      if (allOption.length) { //если есть выбранные опции
        for (let mod in allOption) { // перебираем каждый модификатор в текущем товаре
          let optionArrNow = Object.values(allOption[mod])
          for (let opt in optionArrNow) { // перебираем каждую выбранную опцию в модификаторе текущего товара
            let optionSum = this.OPTIONS[optionArrNow[opt].id].price * optionArrNow[opt].qty //смотрим цену в опциях и умножаем на кол-во
            total += optionSum  // добавляем к цене товара
          }
        }
        return total
      } else {
        return total
      }
    },
    countProductPriceTotal() {
      this.productPriceTotal = this.productPrice + this.countProductModifiersPrice
    },
    emptyComment() {
      if (this.commentForChange === '') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    clearProductIndex() {
      this.productSelectIndex = undefined
      this.productSelected = {}
    },
    selectProduct(index) {
      this.productSelectIndex = index
      this.productSelected = this.RESTAURANTMENU[index] //устанавливаем товар
      this.productVariantSelect = Object.keys(this.RESTAURANTMENU[index].modifiers)[0] //устанавлиаем первую опцию товара
      this.productQty = 1
      this.productOptionsSelect = {}
      this.commentForChange = ''
      this.countPriceBody
    },
    setVariant(value) { //устанавливаем вариант продукта
      this.productVariantSelect = value
      this.productOptionsSelect = {}
      this.countPriceBody
    },
    countSelectedOptionsInModifier(modId) { //количество всех опций в конкретном модификаторе
      let qty = 0
      if (this.productOptionsSelect[modId]) {
        let options = Object.values(this.productOptionsSelect[modId])
        for (let key in options) {
          qty += options[key].qty
        }
      }
      return qty
    },
    optionInfo(optionArr) { // возвращает данные об опциях
      let fullOptionsArr = []
      for (let id of optionArr) {
        fullOptionsArr.push(this.OPTIONS[id])
      }
      return fullOptionsArr
    },
    optionIsSelected(modId, optionId) { //возвращает кол-во выбранных опций
      if(this.productOptionsSelect[modId] && this.productOptionsSelect[modId][optionId]) {
        return this.productOptionsSelect[modId][optionId].qty
      } else {
        return false
      }
    },
    checkCountOption(modId, optionId) { //подсчет сколько опций выбрано в модификаторе
      if(this.productOptionsSelect[modId] !== undefined) {
        if (this.productOptionsSelect[modId][optionId] !== undefined) {
          return this.productOptionsSelect[modId][optionId].qty
        }
      }
    },
    addOption(modId, option) { // добавляем опции
      let optionObj = {
        id: option.id,
        title: option.title,
        qty: 1,
        price: 0, //временный способ, пока не сделаем изменение цены опции
      }
      if (modId in this.productOptionsSelect) { // если есть такой модификатор с опициями
        if (option.id in this.productOptionsSelect[modId]) { // если есть такая опция, то увеличиваем кол-во
          this.productOptionsSelect[modId][option.id].qty++
        } else { //если опции нет, то добавляем её
          this.productOptionsSelect[modId][option.id] = optionObj
        }
      } else { // если модификатора ещё нет, то добавляем его и опцию
        this.productOptionsSelect[modId] = {[option.id]: optionObj}
      }
    },
    reduceOption(modId, optionId) { //уменьшение ко-ва опции
      if (this.productOptionsSelect[modId][optionId].qty === 1) {
        delete this.productOptionsSelect[modId][optionId]
        if (Object.values(this.productOptionsSelect[modId]).length === 0) { //удаляем модификатор если в нём нет больше опций.
          delete this.productOptionsSelect[modId]
        }
      } else {
        this.productOptionsSelect[modId][optionId].qty--
      }
    },
    changeRemovedOption(modId, option) { //изменение удаляемой опции
      let optionObj = {
        id: option.id,
        title: option.title,
        qty: 1,
        price: 0, //временный способ, пока не сделаем изменение цены опции
        removed: true //только для удаляемой опции
      }
      if (modId in this.productOptionsSelect) { // если есть такой модификатор с опициями
        if (option.id in this.productOptionsSelect[modId]) { // если есть такая опция, то убираем её
          delete this.productOptionsSelect[modId][option.id]
          if(Object.values(this.productOptionsSelect[modId]).length === 0) { //удаляем модификатор если в нём нет больше опций..
            delete this.productOptionsSelect[modId]
          }
        } else { //если опции нет, то добавляем её
          this.productOptionsSelect[modId][option.id] = optionObj
        }
      } else { // если модификатора ещё нет, то добавляем его и опцию
        this.productOptionsSelect[modId] = {[option.id]: optionObj}
      }
    },
    addItemInOrder() {
      let restId = this.$route.params.id
      let orderId = this.$route.params.orderId
      let requestBody = {
        'menu_items': [{
          'action': 'ADD',
          'item': {
            'id': this.productSelected.id,
            'size': this.productVariantSelect,
            'size_price': 0,
            'selected_modifiers': this.productOptionsSelect,
            'price': this.productPriceTotal,
            'qty': this.productQty
          }
        }],
        'comment': this.commentForChange
      }
      let payload = { restId, orderId, requestBody }
      this.$store.dispatch('changeMenuItemInOrder', payload)
    }
  },
  watch: {
    'productQty'(e) { // не даем выбрать опций меньше 0
      if (e <= 0) {
        this.productQty = 1
      }
    },
  }
}
</script>

<style scoped>

</style>
